"use client";

import { FC, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import {
  useDisclosure,
  Pagination,
  IconButton,
  ButtonGroup,
} from "@chakra-ui/react";
import { Dialog, Button, Markdown } from "@zerotofinals/design-system";

type Props = {
  title: string;
  slides: string[];
};

const GuideDialog: FC<Props> = ({ title, slides }) => {
  const [page, setPage] = useState(1);
  const { open: isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      onInteractOutside={onClose}
      onEscapeKeyDown={onClose}
      trigger={
        <Button visual="primaryOutline" onClick={onOpen}>
          View guide
        </Button>
      }
      header={title}
    >
      <Markdown>{slides[page - 1]}</Markdown>

      {slides.length > 1 && (
        <Pagination.Root
          count={slides.length}
          pageSize={1}
          defaultPage={1}
          page={page}
          onPageChange={event => setPage(event.page)}
          textAlign="center"
          mt={8}
        >
          <ButtonGroup variant="outline" size="sm" gap={4}>
            <Pagination.PrevTrigger asChild>
              <IconButton>
                <ArrowLeft />
              </IconButton>
            </Pagination.PrevTrigger>
            <Pagination.PageText format="compact" flex="1" />
            <Pagination.NextTrigger asChild>
              <IconButton>
                <ArrowRight />
              </IconButton>
            </Pagination.NextTrigger>
          </ButtonGroup>
        </Pagination.Root>
      )}
    </Dialog>
  );
};

export default GuideDialog;
